import React, { Suspense, FC } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import PreFooter from '../../components/prefooter';
import ArtTools from '../../components/solutions/arttools';
import Main from '../../components/solutions/main';
import Process from '../../components/solutions/process';
import UseCases from '../../components/solutions/usecases';

interface Props {}

const Solutions: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Suspense fallback={<div />}>
      <Helmet>
        <meta
          name="description"
          content="Through years of hands of experience we have developed a bulletproof process and tech stack to build automated data systems to boost your business using Machine Learning."
        />
        <title>
          Mutt Data | Our proven process and technology stack guarantees best of
          breed data products
        </title>
        <meta
          property="og:title"
          content="Mutt Data | Our proven process and technology stack guarantees best of breed data products"
        />
        <meta
          property="og:description"
          content="Through years of hands of experience we have developed a bulletproof process and tech stack to build automated data systems to boost your business using Machine Learning."
        />
        <meta
          property="og:image"
          content={`https://muttdata.ai/email/logo.png`}
        />
        <meta property="og:url" content="https://muttdata.ai/solutions" />
        <meta
          name="keywords"
          content="
machine learning machine-learning ML
ML Ops
data science data-science ciencia de datos
data products productos de datos
Apache Spark Apache Airflow AWS Databricks Hadoop Tensorflow Scikit Learn
"
        />
      </Helmet>
      <Main />
      <Process />
      <ArtTools />
      <UseCases />
      <PreFooter
        title={t('SolutionPrefooterTitle')}
        text={t('SolutionPrefooterText')}
        btnText={t('SolutionPrefooterButton')}
        hasContentOnTop={false}
      />
    </Suspense>
  );
};

export default Solutions;
